import axiosClient from './axiosClient';

// Thin API wrappers. Each unwraps the ApiResponse envelope's .data.
export const listRetailers = (search) =>
  axiosClient.get('/retailers', { params: { search } }).then((r) => r.data?.data ?? []);

export const createRetailer = (payload) =>
  axiosClient.post('/retailers', payload).then((r) => r.data?.data);

export const getRetailer = (cmGuid) =>
  axiosClient.get(`/retailers/${cmGuid}`).then((r) => r.data?.data);

export const updateRetailer = (cmGuid, payload) =>
  axiosClient.put(`/retailers/${cmGuid}`, payload).then((r) => r.data);

export const getRetailerStations = (cmGuid) =>
  axiosClient.get(`/retailers/${cmGuid}/stations`).then((r) => r.data?.data ?? []);

export const getRetailerVisits = (cmGuid) =>
  axiosClient.get(`/retailers/${cmGuid}/visits`).then((r) => r.data?.data ?? []);
